var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogowhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 224,
    viewBox: "0 0 213 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 208,
    height: 215,
    rx: 17.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1611 155.498V145.7H106.133V163.502L88.1241 161.018V155.498H52.4511V184.202H88.1241V178.682L106.133 176.198V194H34.4421V155.498H24.1611ZM110.934 155.498V145.7H134.394L153.99 177.647L173.448 145.7H192.423L162.615 194H145.089L121.215 155.498H110.934Z",
    fill: "#2B0F43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 128V21.8H41.2V128H25ZM46.6 128V21.8H62.8V128H46.6ZM68.2 128V21.8H73.6V128H68.2ZM89.8 128V21.8H95.2V128H89.8ZM100.6 128V21.8H106V128H100.6ZM111.484 128V21.8H116.884V128H111.484ZM133.084 128V21.8H149.284V128H133.084ZM154.684 128V21.8H160.084V128H154.684ZM165.484 128V21.8H170.884V128H165.484ZM176.284 128V21.8H192.484V128H176.284Z",
    fill: "#2B0F43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/logowhite.a90857fec749e5aaa7c6d3aef2d6ee28.svg";
export { ForwardRef as ReactComponent };